<template>
    <div class="pay-body">
        <backindex :msg="payMsg"></backindex>
        <!--顶部信息-->
        <div class="pay-title">
            <p class="pay-user">{{$t("account")}}：{{user.username}}</p>
            <p class="pay-coin">{{$t("balance")}}：<span>{{user.score}}</span>{{$t("coin")}}</p>
        </div>
        <p class="pay-cost" v-if="$J.trim(title)!=''">{{title}}</p>
        <p class="pay-cost" v-if="coin>0">{{$t("price")}}：{{coin}}{{$t("coin")}}</p>


        <div class="style-area">
            <div class="style-item" @click="go.goPaypal(bookId)">{{$t("paypalpay")}}</div>
            <div class="style-item" @click="go.goMyCard(bookId,7,title,coin)">{{$t("台湾")}}</div>
            <div class="style-item" @click="go.goMyCard(bookId,8,title,coin)">{{$t("香港")}}</div>
            <div class="style-item" @click="go.goMyCard(bookId,9,title,coin)">{{$t("马来西亚")}}</div>
            <div class="style-item" @click="go.goMyCard(bookId,10,title,coin)">{{$t("新加坡")}}</div>
            <div class="style-item" @click="go.goPFT(bookId)">{{$t("pftpay")}}</div>
        </div>

        <div class="more-pay-title">
            {{$t("morePay")}}：
        </div>
        <div>
            <div class="downloadImg">
                <img @click="go.downloadApp" src="../../assets/imgs/AppStore.png">
            </div>
            <div class="downloadImg">
                <img @click="go.downloadApp" src="../../assets/imgs/GooglePlay.png">
            </div>
        </div>
        <div class="pay-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
    import backindex from "@/components/common/backindex"
    import pagebottom from "@/components/common/pagebottom"
    export default {
        name: "little",
        components:{
            backindex,
            pagebottom
        },
        mounted: function() {
            this.getUser();
            this.payMsg = this.$t("charge");
            
            fbq('track', 'InitiateCheckout');
            fbq('track', 'Purchase');
        },
        data(){
            return{
                payMsg:"在线储值",
                user:{},
                title:this.$route.query.title,
                coin:this.$route.query.coin,
                bookId:this.$route.query.id,
            }
        },
        methods: {
           getUser:function(){
                this.req.getUser().then(res=>{
                    if(res.data.id>0){
                        this.user = res.data;
                    }else{
                        this.go.goLogin();
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .more-pay-title{
        width: 100%;
        height: 1rem;
        border-top: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
        font-size: 0.34em;
        color: #4d4d4d;
    }
    .pay-body{
        width: 100%;
        height: auto;
    }
    .downloadImg{
        width: 50%;
        float: left;
    }
    .downloadImg img{
        width: 80%;
        margin: 0.4em 10%
    }
    .pay-bottom{
        width: 100%;
        margin-top: 3em;
        left: 0;
        bottom: 0;
    }
    .pay-title{
        width: 100%;
        height: 1.12rem;
        border-bottom: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
    }
    .pay-user,.pay-coin{
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #4d4d4d;
    }
    .pay-coin span{
        color: #ff1f4f;
    }
    .pay-cost{
        width: 100%;
        padding: 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
    }
    .pay-style{
        width: 100%;
        padding: 0 0 0.4rem 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
        display: flex;
        align-items: center;
    }
    /*存储方式*/
    /* .style-area{
        width: auto;
        box-sizing: border-box;
        border: 0.01rem solid #808080;
        border-radius: 0.08rem;
        display: flex;
        position: relative;
    } */
    .style-left{
        padding: 0.12rem 0.26rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
    }
    .coin-left{
        padding: 0.14rem 0.64rem;
        font-size: 0.26rem;
        line-height: 0.26rem;
        color: #666666;
    }
    .style-right{
        width: 0.4rem;
        border-left: 0.01rem solid #808080;
        padding: 0.18rem 0;
    }
    .style-right img{
        display: block;
        width: 0.18rem;
        height: 0.14rem;
        margin: 0 auto;
    }
    .style-options{
        width: 100%;
        height: 2rem;
        border: 0.01rem solid #808080;
        border-top: none;
        background: #FFFFFF;
        text-align: center;
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
        position: absolute;
        left: -0.01rem;
        top: 100%;
        z-index: 99;
        padding-top: 0.08rem;
        box-sizing: border-box;
        border-radius: 0 0 0.08rem 0.08rem;
        animation: show 0.6s;
        overflow-y: auto;
    }
    .options-item{
        padding: 0.1rem 0;
        overflow: hidden;
    }
    .options-select{
        background: #e6e6e6;
    }
    /*下拉展示动画*/
    @keyframes show {
        from {
            height: 0;
        }
        to {
            height: 2rem;
        }
    }
    .option-img{
        transform: rotate(180deg);
        transition: all 0.4s;
    }
    /*获得{{$t("coin")}}*/
    .get-coin{
        width: 100%;
        padding: 0 0.4rem 1rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
    }
    .get-coin span{
        color: #ff1f4f;
    }
    .pay-btn{
        width: 60%;
        box-sizing: border-box;
        padding: 0 0.2rem;
        margin: 0.5em auto;
    }
    .pay-click{
        width: 100%;
        height: 0.84rem;
        font-size: 0.32rem;
        color: #FFFFFF;
        line-height: 0.84rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        text-align: center;
        font-weight: 700;
    }
    .style-area{
        width: 100%;
        height: auto;
        padding: 1rem 0 0 0.4rem;
    }
    .style-item{
        width: 3.16rem;
        height: 0.82rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        box-sizing: border-box;
        text-align: center;
        line-height: 0.82rem;
        color: #ffffff;
        font-size: 0.32rem;
    }
    .style-item{
        float: left;
        margin: 0 0.2rem 1rem 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/pay/pay.vue